require("./src/styles/main.less");

exports.onRouteUpdate = () => {};
